import React from 'react';
import {
  FinanceResponseData,
  FinalFee,
} from '@upstart/harmony/lib/legos/financingTypes';
import { parseCurrencyTruncated } from '@upstart/harmony/lib/form-utils';
import Input, { PriceInput } from '../../../../components/PencilEditor/Input';
import { FormTable } from './FormItems';

const REQUIRED_FEE_FIELDS: (keyof FinalFee)[] = ['paidTo', 'description'];

export function FeeTable(props: {
  columns: {
    title?: string;
    width: string;
    fieldName: keyof FinalFee;
    format?: Function;
  }[];
  fees: FinalFee[];
  responseData: FinanceResponseData;
  onChange: (data: Partial<FinanceResponseData>) => void;
}) {
  const { columns, responseData, fees, onChange } = props;

  const updateFeeList = (
    fee: FinalFee | undefined,
    newData: Partial<FinalFee>,
  ) => {
    const newFeeList = [...(responseData?.finalizedFeeList ?? [])];
    const feeIndex = newFeeList.findIndex(f => f === fee);
    if (feeIndex >= 0) {
      newFeeList[feeIndex] = { ...newFeeList[feeIndex], ...newData };
    }
    return newFeeList;
  };

  return (
    <FormTable
      columns={columns}
      rows={fees.map(fee => ({
        descriptions: columns.map((column, i) => {
          const required =
            REQUIRED_FEE_FIELDS.includes(column.fieldName) &&
            !!fee?.value;
          return (
            <Input
              required={required}
              value={fee[column.fieldName]}
              placeholder="N/A"
              onChange={(val: string) =>
                onChange({
                  finalizedFeeList: updateFeeList(fee, {
                    [column.fieldName]: column.format
                      ? column.format(val)
                      : val,
                  }),
                })
              }
            />
          );
        }),
        value: (
          <PriceInput
            value={fee.value}
            placeholder="N/A"
            onChange={val =>
              onChange({
                finalizedFeeList: updateFeeList(fee, {
                  value: parseCurrencyTruncated(val),
                }),
              })
            }
          />
        ),
      }))}
    />
  );
}

export default FeeTable;
